<template>
    <ul class="list-group list-group-flush">
    <li 
      class="list-group-item" 
      v-for="(field) in fields" :key="field.name"
    >
      {{ field.label }} :
      <!-- <input
        :value="addressToEdit[field.name]"
        @input="update(field.name, $event.target.value)"
      > -->
      <input
        :placeholder="addressInternal[field.name]"
        v-model="addressInternal[field.name]"
      />
    </li>
    </ul>
    <button class="btn btn-primary" @click="$emit('close')">CLOSE</button>
</template>

<script>
export default {
  props: {
    addressToEdit: {
      type: Object,
      required: true
    },
    fields: {
      type: Array,
      required: true
    }
  },
  data () {
    return {
      addressInternal: this.addressToEdit
    }
  }
  // methods: {
  //     update (key, val) {
  //       this.$emit('update:addressToEdit', {
  //         ...this.addressToEdit,
  //         [key]: val
  //       })
  //     }
  // }
}
</script>